// src/CircleRing.tsx
import { jsx } from "react/jsx-runtime";
var CircleRing = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "735",
    height: "735",
    viewBox: "0 0 735 735",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M367.175 40C547.868 40.0003 694.349 186.482 694.349 367.175C694.348 547.868 547.868 694.348 367.175 694.349C186.482 694.349 40.0003 547.868 40 367.175C40 186.481 186.481 40 367.175 40Z",
        strokeWidth: "80"
      }
    )
  }
);
export {
  CircleRing
};
